/**
 * Action types for eogre functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_EOGRE = 'GET_EOGRE';
export const GET_EOGRE_SUCCESS = 'GET_EOGRE_SUCCESS';
export const GET_EOGRE_FAIL = 'GET_EOGRE_FAIL';
export const DELETE_EOGRE = 'DELETE_EOGRE';
export const DELETE_EOGRE_SUCCESS = 'DELETE_EOGRE_SUCCESS';
export const DELETE_EOGRE_FAIL = 'DELETE_EOGRE_FAIL';
export const ADD_EOGRE = 'ADD_EOGRE';
export const ADD_EOGRE_COMPLETE =  'ADD_EOGRE_COMPLETE';
export const EDIT_EOGRE = 'EDIT_EOGRE'
export const EDIT_EOGRE_COMPLETE =  'EDIT_EOGRE_COMPLETE'